import { render, staticRenderFns } from "./UserAdded.vue?vue&type=template&id=1fb18e8f&scoped=true"
import script from "./UserAdded.vue?vue&type=script&lang=js"
export * from "./UserAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb18e8f",
  null
  
)

export default component.exports